import { Grid, Typography, SelectChangeEvent, Paper, PaperProps, styled } from '@mui/material'
import { Applicant } from 'store/dashboard/types'
import CustomChart from './customChart/CustomChart'
import { useState } from 'react'

const CustomPaper = styled((props: PaperProps) => <Paper variant="outlined" {...props} />)(({ theme }) => ({
  marginTop: theme.spacing(2.5),
  marginBottom: theme.spacing(2.5),
  padding: theme.spacing(3),
  backgroundColor: '#f6f8fa',
  borderRadius: '20px',
  borderColor: theme.palette.primary.main,
  borderStyle: 'solid',
  borderWidth: 1,
}))

export default function IpWeigthComponent({ groupedApplicants }: { groupedApplicants: Applicant[] }) {
  const targetCompany = groupedApplicants[0]
  const targetCompanyName = targetCompany.applicant_original_name
  const [topCompaniesNumber, setTopCompaniesNumber] = useState(10)
  const [dataset, setDataset] = useState<Applicant[]>(groupedApplicants)

  const sortedWhalesPatentCount = dataset
    .filter(d => d.applicant_original_name !== targetCompanyName)
    .sort((a, b) => b.whales_patents_in_categories - a.whales_patents_in_categories)
    .slice(0, Number(topCompaniesNumber) - 1) // restamos 1 porque agregamos targetCompany
  const targetEntry = dataset.find(d => d.applicant_original_name === targetCompanyName)
  const chartData = [...(targetEntry ? [{ ...targetEntry }] : []), ...sortedWhalesPatentCount]

  return (
    <Grid mt={2} container spacing={2} columns={{ xs: 4, sm: 6, md: 6, lg: 12 }}>
      <Grid size={{ xs: 4, md: 7 }}>
        <CustomPaper>
          <Typography variant="h6" color="primary.main">
            IP Weight: Whales patent count in all subgroups (whales_patents_in_categories)
          </Typography>
          <CustomChart
            dataset={chartData}
            xKey={'whales_patents_in_categories'}
            xLabel={'Whales patent count in all subgroups'}
            topCompaniesNumber={topCompaniesNumber}
          />
        </CustomPaper>
      </Grid>
      <Grid p={3} size={{ xs: 4, md: 5 }}>
        <Typography sx={{ mt: 1 }} variant="h5" fontWeight={600} pb={2}>
          What does this mean?
        </Typography>
        <Typography sx={{ whiteSpace: 'pre-line' }}>{}</Typography>
      </Grid>
    </Grid>
  )
}
